<div class="row">
  <div class="col-12">
    <div *ngFor="let element of model.elements">
      <app-custom-applicant-element-renderer 
        [model]="element" 
        [hidden]="element !== currentElement"
        [jobId]="jobId"
        (applicantElementUpdated)="updateCustomApplicantElement($event);">
      </app-custom-applicant-element-renderer>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12 text-right">
    <button class="btn-default btn" mdbWavesEffect (click)="displayCancelModal()">Cancel</button>
    <button class="btn-outline btn" mdbWavesEffect *ngIf="canNavigateBackwards" (click)="movePrevious()">Previous</button>
    <button class="btn btn-primary" mdbWavesEffect (click)="save()" [disabled]="!canSave || processingServerSideRequest">
      <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="processingServerSideRequest"></i> Save and Continue
    </button>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12 text-right">
    <a (click)="openSaveAndFinishLater()" [disabled]="processingServerSideRequest" *ngIf="saveAndFinishLaterEnabled" class="saveAndFinishLaterLink">
      Save and Finish Later
    </a>
  </div>
</div>


<div mdbModal #cancelModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form (ngSubmit)="cancel()" novalidate>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="cancelModal.hide()">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title w-100" id="myModalLabel">Cancel Job Application</h4>
        </div>
        <div class="modal-body">
          By canceling, you will lose all data and you'll return to the open jobs page. Are you sure you want to cancel?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" aria-label="Close" (click)="cancelModal.hide()" mdbWavesEffect>No</button>
          <button type="submit" class="btn btn-primary" mdbWavesEffect>Yes</button>
        </div>
      </div>
    </form>
  </div>
</div>

<app-save-and-finish-later [open]="openSaveAndFinishLaterModal" [jobId]="jobId" (saved)="saveAndFinishLater($event)" (closed)="closeSaveAndFinishLater()"></app-save-and-finish-later>
